<template>
    <div class="z-input-file">
        <label
            :for="name"
            class="z-input-file__label"
            :class="{
                'is-disabled': disabled
            }"
        >
            <input
                :id="name"
                type="file"
                :name="name"
                ref='file'
                :multiple="multiple"
                :disabled="disabled"
                @change="change($event.target)"
                :accept="accept"
            />
            <z-icon
                width="24"
                height="24"
                name="attach"
            />
            <span>
                <slot>{{ text.attach }}</slot>
            </span>
        </label>
        <span
            class="z-input__error vm-form-el__error"
            v-if="required && error"
        >
            <span v-if="!files.length">{{ text.required }}</span>
        </span>
        <div
            v-if="files.length"
            class="z-input-file__filelist"
        >
            <div
                :key="index"
                class="z-input-file__file"
                v-for="(file, index) in files"
            >
                <span>{{ file }}</span>
                <z-icon
                    width="24"
                    height="24"
                    name="close"
                    @click="remove(file)"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'z-input-file',
    props: {
        name: {
            type: String,
            required: true
        },
        disabled: Boolean,
        multiple: Boolean,
        accept: String,
        required: Boolean
    },
    data () {
        return {
            files: [],
            error: false,
            uploaded: [],
            text: {
                required: this.$root.lang === 'ru' ? 'Поле обязательно для заполнения' : 'Required field',
                attach: this.$root.lang === 'ru' ? 'Прикрепить файлы' : 'Attach files'
            }
        }
    },
    mounted () {
        this.$root.$bus.$on('clear', name => {
            if (this.name === name) this.clear()
        })
    },
    beforeDestroy () {
        this.$root.$bus.$off('clear', name => {
            if (this.name === name) this.clear()
        })
    },
    methods: {
        change (data) {
            this.buildList(data)
            this.$nextTick(() => this.$emit('change', { value: this.uploaded, name: this.name }))
        },
        clear () {
            this.files = []
            this.uploaded = []
            this.$refs.file.value = null
            this.$nextTick(() => this.$emit('change', { value: this.uploaded, name: this.name }))
            this.validate()
        },
        buildList (data) {
            if (this.multiple) {
                this.files = []
                this.uploaded = data.files

                for (let i = 0; i < data.files.length; i++) {
                    this.files.push(data.files[i].name)
                }
            } else {
                this.uploaded = data.files[0]
                this.files = [data.files[0].name]
            }
        },
        updateList (data) {
            this.files = Array.from(data).map(item => item.name)
        },
        remove (file) {
            let dt = new DataTransfer()
            this.$refs.file.files.forEach(item => {
                if (file !== item.name) {
                    dt.items.add(item)
                }
            })

            if (dt.files.length === 0) {
                this.clear()
                return
            }

            this.$refs.file.files = dt.files
            this.uploaded = dt.files
            this.updateList(this.$refs.file.files)

            this.$nextTick(() => this.$emit('change', { value: this.uploaded, name: this.name }))
            this.validate()
        },
        validate () {
            if (this.required && !this.files.length) {
                this.error = true
            } else {
                this.error = false
            }
        }
    }
}

</script>

<style lang="scss">
.z-input-file {
    display: flex;
    flex-flow: row wrap;
    position: relative;

    input {
        display: none;
    }

    &__label {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 21px $token-spacers-m;
        font-size: 18px;
        font-weight: 500;
        line-height: 1.2;
        text-align: center;
        text-decoration: none;
        color: $token-colors-black;
        outline: 0;
        border: none;
        background-color: transparent;
        box-shadow: inset 0 0 0 1px $token-colors-black-20;
        transition: all $transition;
        cursor: pointer;
        border-radius: 120px;
        line-height: 1;

        &:active,
        &:hover {
            box-shadow: inset 0 0 0 1px #EE7918;
        }

        .z-icon {
            margin-right: $token-spacers-xs;
        }

        @include breakpoint(mobile) {
            width: 100%;
            font-size: 14px;
        }
    }

    &__filelist {
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        padding-left: $token-spacers-l;

        @include breakpoint(mobile) {
            width: 100%;
            margin-top: $token-spacers-s;
        }
    }

    &__file {
        position: relative;
        line-height: 1.5;
        white-space: nowrap;

        @include breakpoint(v-tablet) {
            white-space: pre-wrap;
        }

        svg {
            cursor: pointer;
        }

        span {
            font-size: 14px;
            line-height: 1.5;
        }
    }

    &.is-disabled {
        opacity: .8;
        pointer-events: none;
    }
}
</style>
